import { css } from '@emotion/css';

const style =  {
    container: css({
        backgroundColor: '#fff'
    }),
};

export default style;